import SysButtons from "config/lang/SysButtons";

const Buttons = {
  ...SysButtons,
  removeLines: "Eliminar líneas",
  removeLastLine: "Eliminar última línea",
};

export default Buttons;
